import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import { useSettingsContext } from '../../components/settings';
//
import Main from './Main';
import Header from './header';
import NavMini from './nav/NavMini';
import NavVertical from './nav/NavVertical';
import NavHorizontal from './nav/NavHorizontal';
import getAuthData from 'src/services/auth-api';
import { useAuthContext } from 'src/auth/useAuthContext';
import { useAuthValidator } from 'src/store/AuthValidater';
import { organizeMenuItems } from 'src/auth/JwtContext';

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { themeLayout } = useSettingsContext();
  const { user } = useAuthContext()
  const { menus, handleMenus } = useAuthValidator((state) => state)
  // console.log(menus, "menus");

  const [menusData, setMenusData] = useState([])
  const isDesktop = useResponsive('up', 'lg');

  const [open, setOpen] = useState(false);

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  // function organizeMenuItems(menuItems) {
  //   const menuMap = {};
  //   menuItems?.forEach((item) => {
  //     menuMap[item?._id] = { ...item, children: [] };
  //   });
  //   const topLevelItems = [];
  //   menuItems?.forEach((item) => {
  //     if (item?.parent && menuMap[item?.parent]) {
  //       menuMap[item?.parent]?.children?.push(menuMap[item._id]);
  //     } else {
  //       topLevelItems.push(menuMap[item._id]);
  //     }
  //   });
  //   // Recursive sort function by order
  //   const sortByOrder = (items) => {
  //     items.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  //     items.forEach(item => {
  //       if (item.children?.length) {
  //         sortByOrder(item.children);
  //       }
  //     });
  //   };

  //   sortByOrder(topLevelItems);
  //   return topLevelItems;
  // }

  useEffect(() => {
    const fetchData = async () => {
      const data = await getAuthData(user)
      //  console.log(data,"data_ddd")
      if (data?.admin_menu) {
        const menusData = data?.admin_menu.map((it) => {
          return {
            ...it.menu
          }
        })
        const organizedMenu1 = organizeMenuItems(menusData);
        //  console.log(organizedMenu1,"organizedMenu1")
        handleMenus(organizedMenu1)
      }
    }
    fetchData()
  }, [])



  const renderNavVertical = <NavVertical openNav={open} onCloseNav={handleClose} />;

  if (isNavHorizontal) {
    return (
      <>
        <Header onOpenNav={handleOpen} />

        {isDesktop ? <NavHorizontal /> : renderNavVertical}

        <Main>
          <Outlet />
        </Main>
      </>
    );
  }

  if (isNavMini) {
    return (
      <>
        <Header onOpenNav={handleOpen} />

        <Box
          sx={{
            display: { lg: 'flex' },
            minHeight: { lg: 1 },
          }}
        >
          {isDesktop ? <NavMini /> : renderNavVertical}

          <Main>
            <Outlet />
          </Main>
        </Box>
      </>
    );
  }

  return (
    <>
      <Header onOpenNav={handleOpen} />

      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: 1 },
        }}
      >
        {renderNavVertical}

        <Main>
          <Outlet />
        </Main>
      </Box>
    </>
  );
}
